import { PageSectionType } from '../enums/page-section-type';
import { IState } from '../interfaces/store.interfaces';
import { reactive } from 'vue';
import { ScholarshipRequirementType } from '@studyportals/eligibility-model';
import { JourneyMenuTab } from '@/enums/journey-menu-tab';

const state: IState = reactive({
	activePageSection: PageSectionType.PROFILE,
	gender: 'neutral',
	name: '',
	email: '',
	countriesOfInterest: [],
	disciplinesOfInterest: [],
	attendance: [],
	residenceCountry: '',
	nationalityCountry: '',
	startDate: '',
	profileCompleteness: 0,
	isMenuActive: true,
	contentSwitcher: {},
	isInitialStudentDataLoaded: false,
	isLoggedIn: false,
	journeySteps: [],
	currentStep: null,
	showHelper: false,
	currentJourneyMenuTab: JourneyMenuTab.MY_JOURNEY,
	wishlistStudyCount: 0,
	journeyState: null,
	evaluateView: false,
	hasFavouritesInIsApplyingState: false,
	numberOfFavouritesInIsApplyingState: 0,
	numberOfFavouritesHasAppliedState: 0,
	creatingApplicationChecklistView: false,
	emailingFavourites: false,
	emailingOther: false,
	emailingScholarships: false,
	emailingUpdates: false,
	areDependenciesLoaded: false,
	scholarshipEligibility: {
		[ScholarshipRequirementType.CREATED_ACCOUNT]: false,
		[ScholarshipRequirementType.EMAIL_SUBSCRIPTIONS]: false,
		[ScholarshipRequirementType.STUDY_PREFERENCES]: false,
		[ScholarshipRequirementType.BEST_FIT]: false,
		[ScholarshipRequirementType.REVIEW]: false,
		[ScholarshipRequirementType.APPLIED]: false,
		[ScholarshipRequirementType.APPLICATION_LETTER]: false,
		[ScholarshipRequirementType.CONFIRM_ACCEPTANCE]: false,
	},
	scholarshipEligibilityFlags: {},
	currentRoute: null,
});

export default state;
